"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../../utils");

var AdtFlag_1 = require("../../AdtFlag");

var Parser_1 = require("../Parser");

var parserSupport_1 = require("../parserSupport");

var ValidationResult_1 = require("../ValidationResult");

var AdtFlagConstructorParser =
/*#__PURE__*/
function (_Parser_1$Parser) {
  _inherits(AdtFlagConstructorParser, _Parser_1$Parser);

  function AdtFlagConstructorParser(flagBase) {
    var _this;

    _classCallCheck(this, AdtFlagConstructorParser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AdtFlagConstructorParser).call(this));
    _this.flagBase = flagBase;
    return _this;
  }

  _createClass(AdtFlagConstructorParser, [{
    key: "parse",
    value: function parse(input, level) {
      if (utils_1.Utils.isString(input)) {
        var flag = AdtFlag_1.AdtFlag.getConstructorBase(this.flagBase, input);
        return parserSupport_1.succ(flag);
      }

      return new ValidationResult_1.ValidationError(parserSupport_1.UNSUPPORTED_VALUE_ERROR, null);
    }
  }]);

  return AdtFlagConstructorParser;
}(Parser_1.Parser);

exports.AdtFlagConstructorParser = AdtFlagConstructorParser;